import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Box, Typography } from "@mui/material";
import vehicleImage from "app/assets/vechile.svg";
import React from "react";
import { useTranslation } from "react-i18next";
import { WorkOrderVehicleDetails } from "../../../types";
import { useStyles } from "./styles";

type FieldProps = {
  label: string;
  value: string;
  hasDropdown?: boolean;
};

type Props = {
  data: WorkOrderVehicleDetails;
};

const DetailField = ({ label, value, hasDropdown = false }: FieldProps) => {
  const styles = useStyles();

  return (
    <Box className={styles.field}>
      <Typography className={styles.label}>{label}</Typography>
      <Box className={styles.valueRow}>
        {hasDropdown ? (
          <KeyboardArrowDownIcon className={styles.chevron} />
        ) : null}
        <Typography className={styles.value}>{value}</Typography>
      </Box>
    </Box>
  );
};

const SummaryBar = ({ data }: Props) => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();

  const getCustomerName = (key: string) =>
    t(`WORK_ORDER.VEHICLE_DETAILS.CUSTOMER_VALUES.${key}`, key);

  return (
    <Box className={styles.root} dir={i18n.dir()}>
      <Box className={styles.fieldsRow}>
        <Box className={styles.imageCell}>
          <img
            src={vehicleImage}
            alt={t("WORK_ORDER.VEHICLE_DETAILS.VEHICLE_IMAGE_ALT")}
            className={styles.vehicleImage}
          />
        </Box>

        <DetailField
          label={t("WORK_ORDER.VEHICLE_DETAILS.WORK_ORDER_NO")}
          value={data.workOrderNo}
        />
        <DetailField
          label={t("WORK_ORDER.VEHICLE_DETAILS.CUSTOMER_NAME")}
          value={getCustomerName(data.customerName)}
        />
        <DetailField
          label={t("WORK_ORDER.VEHICLE_DETAILS.SUB_CUSTOMER")}
          value={getCustomerName(data.subCustomer)}
        />
        <DetailField
          label={t("WORK_ORDER.VEHICLE_DETAILS.CHASSIS")}
          value={data.chassis}
        />
        <DetailField
          label={t("WORK_ORDER.VEHICLE_DETAILS.MANUFACTURER")}
          value={t(
            `WORK_ORDER.VEHICLE_DETAILS.MANUFACTURER_VALUES.${data.manufacturer}`
          )}
        />
        <DetailField
          label={t("WORK_ORDER.VEHICLE_DETAILS.MODEL")}
          value={data.model}
        />
        <DetailField
          label={t("WORK_ORDER.VEHICLE_DETAILS.AXLE_STRUCTURE")}
          value={data.axleStructure}
          hasDropdown
        />
        <DetailField
          label={t("WORK_ORDER.VEHICLE_DETAILS.YEAR")}
          value={data.year}
        />
        <DetailField
          label={t("WORK_ORDER.VEHICLE_DETAILS.BOX_TYPE")}
          value={t(
            `WORK_ORDER.VEHICLE_DETAILS.BOX_TYPE_VALUES.${data.boxType}`
          )}
          hasDropdown
        />
      </Box>
    </Box>
  );
};

export default SummaryBar;
